import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-spinner',
  template: `<div class="animate-spin rounded-full h-6 w-6 border-t-2 border-primary"></div>`
})
export class SpinnerComponent {}
